export function rutaCuerpo(cuerpoSlug, ruta = "/") {
  const slug = String(cuerpoSlug || "").trim().toLowerCase();
  const path = ruta.startsWith("/") ? ruta : `/${ruta}`;

  if (!slug) return path;
  if (path === "/") return `/${slug}`;
  return `/${slug}${path}`;
}
